import {translation} from "@2d-front-monorepo/core";
import {Icon} from "@2d-front-monorepo/design-library";
import React, {JSX, memo} from "react";
import {createAttachmentHref} from "../helpers/createAttachmentHref";
import {attachmentTypeLabel} from "../helpers/enumNaming";
import IAttachments from "../interfaces/IAttachments";
import {AttachmentResult} from "../types/AttachmentResult";
import {AttachmentStatusComponent} from "./AttachmentStatusComponent";

export interface EntityDocumentationProps {
	linkPrefix: string;
	entity: IAttachments;
}

interface EntityAttachmentProps {
	attachment: AttachmentResult;
	linkPrefix: string;
}

const EntityAttachment = memo(function EntityAttachment({attachment, linkPrefix}: EntityAttachmentProps): JSX.Element {
	const label = translation(attachmentTypeLabel(attachment.type));
	const href = createAttachmentHref(attachment, linkPrefix);

	return <li className="entity-documentation-entry">
		<a href={href} download target="_blank"><Icon icon="dowload-image"/>{label}</a>
		<AttachmentStatusComponent attachment={attachment} small={false}/>
	</li>;
});

const EntityDocumentation = memo(function EntityDocumentation(documentation: EntityDocumentationProps): JSX.Element {
	const {entity, linkPrefix} = documentation;
	const attachments = entity.attachments;
	if (attachments.length === 0) {
		return <></>;
	}

	return <ol className="entity-documentation-list">
		{attachments.map(((attachment, i) =>
			<EntityAttachment key={i} attachment={attachment} linkPrefix={linkPrefix}/>)
		)}
	</ol>;
}) as React.MemoExoticComponent<(props: EntityDocumentationProps) => JSX.Element>;

export default EntityDocumentation;
